import { useEffect, useState } from 'react'
import { useRemoteClientPost } from '../../../../../configs/http-client'
import { CatchMessageError } from '../../../../../remote/catch-message-error'
import { useLocalStorage } from '../../../../../remote/local-storage'

export const loadServices = () => {
  const { getUnitId } = useLocalStorage()
  const { httpClientPost } = useRemoteClientPost()
  const [data, setData] = useState<any[] | null>(null)
  const [loading, setLoading] = useState(false)

  useEffect(() => {
    if (!loading) {
      setLoading(true)
      httpClientPost('/servicos/filtro', {
        unidade: {
          id: getUnitId()
        }
      })
        .then((response) => {
          console.debug({ response })
          setData(
            response.data.data.content.map((item: any) => ({
              ...item,
              label: item.nome,
              value: item.id.toString()
            }))
          )
        })
        .catch(CatchMessageError)
        .finally(() => setLoading(false))
    }
  }, [])

  return {
    data
  }
}
